// import { LangType } from './constants/LangType';
import {
  PV04FormSchema,
  Option,
  PV04FormField,
} from 'app/components/PV04Form/components/types';
import { Scheme } from 'app/pages/Payment/data';
// import CryptoJS from 'crypto-js';

let MERCHANT_ID: string = '';
let SECRET_KEY: string = '';
let BACK_ORIGIN_URL: string = '';
let CLIENT_KEY: string = '';

export const checkEmail = (value: string): boolean => {
  const regExp: RegExp =
    /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
  return regExp.test(value);
};

export const checkNumber = (t: any): boolean => {
  const num = Number(t);
  if (isNaN(num)) {
    return false;
  }

  //뛰어쓰기 입력 방지
  const regex = /^\s*$/;
  if (regex.test(String(t))) {
    return false;
  }

  if (num >= 0 && num <= 9) {
    return true;
  }
  return false;
};

export const setBackOriginUrl = (url: string): void => {
  BACK_ORIGIN_URL = url;
};

export const getBackOriginUrl = (): string => {
  return BACK_ORIGIN_URL;
};

export const setMerchantIdcKey = (id: string, cKey: string): void => {
  MERCHANT_ID = id;
  CLIENT_KEY = cKey;
};

export const setMerchantIdsKey = (id: string, sKey: string): void => {
  MERCHANT_ID = id;
  SECRET_KEY = sKey;
};

export const getMerchantId = (): string => {
  return MERCHANT_ID;
};

export const getSecretKey = (): string => {
  return SECRET_KEY;
};

export const getClientKey = (): string => {
  return CLIENT_KEY;
};

export const isEmpty = (value: any): boolean => {
  return value === undefined || value === null || value === '';
};

export const isNotEmpty = (value: any): boolean => {
  return !isEmpty(value);
};

export const cardFormat = (value: string): string => {
  let v: string = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
  let matches: RegExpMatchArray | null = v.match(/\d{4,16}/g);
  let match: string = (matches && matches[0]) || '';
  let parts: string[] = [];
  for (let i = 0, len = match.length; i < len; i += 4) {
    parts.push(match.substring(i, i + 4));
  }
  if (parts.length) {
    return parts.join(' ');
  } else {
    return value;
  }
};

export const expiryFormat = (value: string): string => {
  const tempValue: string = value.replace('/', '');

  if (tempValue.length === 4) {
    return value.replace(/(\d{2})(\d{2})/, '$1/$2');
  } else {
    return tempValue;
  }
};

export const checkValidExp = (value: string): boolean => {
  if (!value.includes('/')) {
    return false;
  }

  try {
    const tempValue: string[] = value.split('/');
    const month: number = Number(tempValue[0]);
    const year: number = Number(tempValue[1]);
    if (month > 12) {
      return false;
    }

    const expValue: Date = new Date(20 + year, month - 1, 0);
    const today: Date = new Date();

    if (today > expValue) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};

export const findImage = (path: string): string => {
  const defaultPath: string = process.env.PUBLIC_URL + '/image/';
  // 특정 문자열이 포함되면 확장자를 svg로 변경
  if (
    path.includes('APPLE') ||
    path.includes('NAVER') ||
    path.includes('SENCILLITO') ||
    path.includes('VIETQR')
  ) {
    path = path.replace('.png', '.svg');
  }
  if (
    path.includes('SERVIPAG') ||
    path.includes('WEBPAY') ||
    path.includes('BANCONTACT') ||
    path.includes('BLIK')
  ) {
    path = path.replace('.png', '.webp');
  }
  return defaultPath + 'common/' + path;
};

export const getQueryString = (name: string): string | null => {
  return new URLSearchParams(window.location.search).get(name);
};

export const standardCountryName = (country: string): string => {
  if (country === 'usa') {
    return country.toUpperCase();
  } else if (country === 'domestic') {
    return 'Korea';
  } else if (country === 'hongkong') {
    return 'Hong kong';
  }

  return country.charAt(0).toUpperCase() + country.slice(1);
};

// export const encryptAesECB = (srcText: string, secretKey: string): string => {
//   const encrypted: string = CryptoJS.AES.encrypt(
//     srcText,
//     CryptoJS.enc.Utf8.parse(secretKey),
//     {
//       mode: CryptoJS.mode.ECB,
//     },
//   ).toString();

//   return encrypted;
// };

export function isEmptyObject(obj: { [key: string]: Scheme[] }): boolean {
  return Object.keys(obj).length === 0 ? false : true;
}

export const addCommasToNumber = (number: any): string => {
  if (number === 0e-9 || number === 0 || !number) return '0.00';

  let numStr;
  let decimal = null;

  // 입력받은 숫자를 문자열로 변환
  numStr = number?.toString();

  //소수점이 있을 경우 두자리로 잘라줌
  if (numStr?.includes('.')) {
    const split = numStr.split('.');
    decimal =
      split[1]?.slice(0, 2).length < 2
        ? `${split[1]?.slice(0, 2)}0`
        : split[1]?.slice(0, 2);
    numStr = split[0];
  }

  // 정규식을 사용하여 세 자리마다 쉼표 추가
  numStr = numStr?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return decimal === null ? `${numStr}.00` : `${numStr}.${decimal}`;
};

// constants/paymentConfig.js
export const PAYMENT_TOKEN_CONFIG = {
  STORAGE_KEY: 'auth',
  EXPIRY_BUFFER_SECONDS: 30, // 네트워크 지연 고려한 버퍼 개발용 1799 (1초만에 만료)
  JWT_PARTS_COUNT: 3, // JWT(Header, Payload, Signature) 3개의 값을 갖는 구조
};

/**
 * JWT 토큰 구조 유효성 검증
 * @param {string} token - 검증할 토큰
 * @returns {boolean} 유효성 여부
 */
function isValidJWTStructure(token) {
  if (!token || typeof token !== 'string') {
    return false;
  }

  const parts = token.split('.');
  return parts.length === PAYMENT_TOKEN_CONFIG.JWT_PARTS_COUNT;
}

/**
 * Base64 URL 디코딩 (JWT 표준)
 * @param {string} str - 디코딩할 문자열
 * @returns {string} 디코딩된 문자열
 */
function base64UrlDecode(str) {
  // JWT Base64 URL 인코딩 처리
  let base64 = str.replace(/-/g, '+').replace(/_/g, '/');

  // 패딩 추가
  const padding = base64.length % 4;
  if (padding) {
    base64 += '='.repeat(4 - padding);
  }

  return atob(base64);
}

/**
 * 결제 토큰 만료 여부 확인
 * @returns {boolean} 만료 여부 (true: 만료됨, false: 유효함)
 */
export function isPaymentTokenExpired() {
  const token = sessionStorage.getItem(PAYMENT_TOKEN_CONFIG.STORAGE_KEY);

  // 토큰이 없으면 만료로 간주
  if (!token) {
    return true;
  }

  try {
    // JWT 구조 검증
    if (!isValidJWTStructure(token)) {
      console.warn('⚠️ 결제 토큰 구조가 올바르지 않습니다');
      return true;
    }

    // 페이로드 추출 및 디코딩
    const payloadBase64 = token.split('.')[1];
    const decodedPayload = JSON.parse(base64UrlDecode(payloadBase64));

    // 만료시간(exp) 확인
    const { exp } = decodedPayload;
    if (!exp || typeof exp !== 'number') {
      console.warn('⚠️ 결제 토큰에 유효한 만료시간이 없습니다');
      return true;
    }

    // 현재 시간과 비교 (버퍼 시간 포함)
    const currentTimestamp = Math.floor(Date.now() / 1000);
    const bufferedCurrentTime =
      currentTimestamp + PAYMENT_TOKEN_CONFIG.EXPIRY_BUFFER_SECONDS;

    const isExpired = bufferedCurrentTime >= exp;

    if (isExpired) {
      console.info('ℹ️ 결제 토큰이 만료되었습니다');
    }

    return isExpired;
  } catch (error: any) {
    console.error('⚠️ 결제 토큰 검증 중 오류 발생:', error.message);
    // 파싱 오류 시 보안상 만료로 간주
    return true;
  }
}
export const convertToOptions = <T extends Record<string | number, any>>(
  data: T[],
  key: keyof T,
  value: keyof T,
): Option[] => {
  return data.map(item => ({
    value: `${item[key]}`,
    label: `${item[value]}`,
  }));
};

export function convertToPV04FormSchema(requireData: {
  [key: string]: {
    type: string;
    length: string;
    description?: string;
    value?: { [key: string]: string }[];
  };
}): PV04FormSchema {
  const fields: PV04FormField[] = Object.entries(requireData).map(
    ([key, value]) => {
      let selectOption: Option[];

      // 이런식으로 key를 비교하기보다 다른 값을 만들어서 동적으로 완성되도록 개선할 수 있는
      if (key === 'country' || key === 'bankCode') {
        selectOption = convertToOptions(value.value ?? [], 'code', 'name');

        return {
          name: key,
          type: value.type,
          length: value.length,
          selectOption: selectOption ?? [],
          renderType: `select_${key}`,
        };
      }

      return {
        name: key,
        type: value.type,
        length: value.length,
        renderType: 'input',
        description: value.description,
      };
    },
  );

  return { fields };
}

export const convertInstallmentStringToOptions = (
  raw: string,
  t: (key: string) => string,
): Option[] => {
  return raw
    .split(',')
    .map(v => v.trim())
    .filter(Boolean)
    .map(value => ({
      label: t(`installment-${value}`),
      value,
    }));
};
